// Petits comportements du thème : filtres qui se soumettent seuls, choix de variante, vignettes, panier.
document.addEventListener('DOMContentLoaded', () => {
  // Filtres et tri : on recharge la liste dès qu'un choix change.
  const facets = document.getElementById('facets')
  if (facets) {
    facets.addEventListener('change', () => facets.requestSubmit())
    document.querySelectorAll('[data-sort]').forEach((s) => s.addEventListener('change', () => facets.requestSubmit()))
    facets.addEventListener('submit', (e) => {
      // On retire les champs vides pour garder des adresses propres.
      e.preventDefault()
      const params = new URLSearchParams()
      new FormData(facets).forEach((v, k) => { if (v !== '') params.append(k, v) })
      location.search = params.toString()
    })
  }

  // Fiche produit : le prix, le stock et la photo suivent la variante choisie.
  const select = document.querySelector('[data-variant-select]')
  if (select) {
    const majVariante = () => {
      const o = select.selectedOptions[0]
      const prix = document.querySelector('[data-price]')
      prix.innerHTML = (o.dataset.compare ? `<s>${o.dataset.compare}</s> ` : '') + `<b>${o.dataset.price}</b>`
      const dispo = o.dataset.available === 'true'
      const stock = document.querySelector('[data-stock]')
      stock.className = dispo ? 'in' : 'oos'
      stock.textContent = dispo ? '● En stock, retrait en boutique possible' : 'Épuisé pour le moment'
      document.querySelector('[data-add]').disabled = !dispo
      if (o.dataset.image) montrer(o.dataset.image)
      const url = new URL(location.href)
      url.searchParams.set('variant', select.value)
      history.replaceState(null, '', url)
    }
    select.addEventListener('change', majVariante)
  }

  const principale = document.querySelector('[data-main-media] img')
  function montrer(src) {
    if (!principale) return
    principale.removeAttribute('srcset')
    principale.src = src
  }
  document.querySelectorAll('[data-thumb]').forEach((b) =>
    b.addEventListener('click', () => {
      montrer(b.dataset.thumb)
      document.querySelectorAll('[data-thumb]').forEach((x) => x.classList.toggle('on', x === b))
    }),
  )

  // Panier : changer une quantité met le panier à jour.
  document.querySelectorAll('[data-autosubmit-cart]').forEach((i) =>
    i.addEventListener('change', () => {
      const f = document.getElementById('cart')
      const b = document.createElement('input')
      b.type = 'hidden'
      b.name = 'update'
      b.value = '1'
      f.appendChild(b)
      f.submit()
    }),
  )

  // Connexion : afficher le formulaire « mot de passe oublié ».
  const recover = document.getElementById('recover')
  if (recover && location.hash !== '#recover' && !recover.querySelector('.errors, .in')) recover.hidden = true
  document.querySelectorAll('[data-toggle-recover]').forEach((a) => a.addEventListener('click', () => (recover.hidden = false)))
})
